import { Injectable } from '@angular/core';

import { AppConfig, BreakPoint, DeviceType } from 'app.config';


@Injectable()
export abstract class SPAConfigurationService <T extends AppConfig> {

  private innerConfig?: T;

  public get config(): T {
    if (!isDefined(this.innerConfig)) {
      throw new Error('Configuration not found');
    }
    return this.innerConfig;
  }

  public set config(config: T) {
    try {
      this.validateBreakpoints(config.breakpoints);
      this.innerConfig = config;
    } catch (error) {
      throw new Error(`Breakpoints provided by configuration are invalid. ${error}`);
    }
  }

  protected validateBreakpoints(breakpoints: BreakPoint[]): void {
    let hasRepeatedDevices = false;
    const isDeviceSet = breakpoints.every((breakpoint: BreakPoint) => breakpoint.device.length > 0);

    Object.values(DeviceType).forEach((value: string | DeviceType) => {
      // Iterate over enums returns keys and values (ex: ['0', '1', '2', 'DESKTOP', 'TABLET' ...])
      if (!isNaN(Number(value))) {
        const numRepeticiones = breakpoints.filter((breakpoint: BreakPoint) => breakpoint.device.some((bk: DeviceType) => bk === value)).length;
        hasRepeatedDevices = hasRepeatedDevices || numRepeticiones > 1;
      }
    });

    if (!isDeviceSet) {
      throw new Error('There are breakpoints without a device defined');
    }

    if (hasRepeatedDevices) {
      throw new Error('There are breakpoints with repeated devices');
    }
  }

}
